__turbopack_context__.v({
  "bodyContainer": "tileAccessFallback-module-scss-module__VY91eW__bodyContainer",
  "container": "tileAccessFallback-module-scss-module__VY91eW__container",
  "description": "tileAccessFallback-module-scss-module__VY91eW__description",
  "title": "tileAccessFallback-module-scss-module__VY91eW__title",
  "vertical": "tileAccessFallback-module-scss-module__VY91eW__vertical",
});
